import { aboutParagraphs } from '@/mocks/content';

const keywordChips = [
  '完整版',
  '未删减',
  '高清修复',
  '国语中字',
  '在线播放',
  '迅雷下载',
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full scroll-mt-20 bg-[#fffbf5] py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-8">
            <span className="text-sm font-medium text-orange-600">影片概览</span>
            <h2 className="font-heading mt-2 text-2xl md:text-4xl font-bold text-stone-900">
              为什么同一部片子，会有这么多种版本？
            </h2>
            <div className="mt-6 space-y-4">
              {aboutParagraphs.map((p, i) => (
                <p key={i} className="text-stone-600 leading-relaxed">
                  {p}
                </p>
              ))}
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="bg-white border border-stone-200 rounded-xl p-6 sticky top-20">
              <h3 className="font-heading text-lg font-semibold text-stone-900 flex items-center gap-2">
                <i className="ri-price-tag-3-line text-orange-500" aria-hidden="true"></i>
                你会用到的检索词
              </h3>
              <p className="mt-2 text-sm text-stone-500">
                把片名与下面的词组合使用，检索会更精准。
              </p>
              <div className="mt-4 flex flex-wrap gap-2">
                {keywordChips.map((chip) => (
                  <span
                    key={chip}
                    className="px-3 py-1.5 rounded-full bg-orange-100 text-orange-700 text-sm"
                  >
                    {chip}
                  </span>
                ))}
              </div>
              <div className="mt-5 pt-5 border-t border-stone-200 flex items-start gap-2 text-sm text-stone-500">
                <i className="ri-information-line text-orange-500 mt-0.5" aria-hidden="true"></i>
                <p>能组合使用就不要只搜单个词；组合检索能显著减少无关结果。</p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}